<template>
  <div class="healthcare-box" :class="data.bgColor">
    <div class="healthcare-box-title">
      {{data.title}}
    </div>
    <div class="healthcare-box-categories" >
      <div v-for="cat in data.categories" :key="cat.title" class="cat pt-3 pb-3">
        <div class="cat-image">
          <figure>
            <img
              class="icon"
              alt="Vue logo"
              :src="cat.icon"
            />
          </figure>
        </div>
        <div class="cat-title pt-2">{{cat.title}}</div>
        <div class="cat-description pt-1">{{cat.description}}</div>
      </div>
    </div>
    <div class="know-more pt-5">
      saiba mais
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthcareBox',
  props: ['data']
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.healthcare-box {
  margin: 0.8rem;
  color: $white;
  min-height: 43rem;
  cursor: pointer;
}

.healthcare-box-title {
  padding: 2rem;
  font-size: 2rem;
  text-transform: uppercase;
  font-weight: bold;
}

.healthcare-box-categories{
  display: flex;
  justify-content: space-around;
  min-height: 26rem;
}

.cat {
  width: 100%;

  &:first-child {
    border-right: 2px $white solid;
  }
}

.cat-image {
  img {
    height: 7.5rem;
  }
}

.cat-title {
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: uppercase;
}

.cat-description {
  font-size: 1.4rem;
  text-transform: uppercase;
}

.know-more {
  font-size: 1.6rem;
  font-weight: bold;
  text-transform: uppercase;
}

.green {
 background-color: $green;
}

.light-blue {
 background-color: $light-blue;
}

.blue {
 background-color: $blue;
}
</style>
